import { render, staticRenderFns } from "./StaffingSummaryBanner.vue?vue&type=template&id=33b02efa&scoped=true&"
import script from "./StaffingSummaryBanner.vue?vue&type=script&lang=ts&"
export * from "./StaffingSummaryBanner.vue?vue&type=script&lang=ts&"
import style0 from "./StaffingSummaryBanner.vue?vue&type=style&index=0&id=33b02efa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b02efa",
  null
  
)

export default component.exports